import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730b35a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_3 = { style: {"float":"right","display":"inline-block","width":"152px"} }
const _hoisted_4 = { class: "el-input__wrapper" }
const _hoisted_5 = { class: "el-input__inner" }
const _hoisted_6 = { class: "el-input__wrapper" }
const _hoisted_7 = { class: "el-input__inner" }
const _hoisted_8 = {
  colspan: "10",
  class: "packages"
}
const _hoisted_9 = { class: "packages-top" }
const _hoisted_10 = { class: "goodsDataList" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "货物数据", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { colspan: "10" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c","margin-right":"4px"} }, "*", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_23 = ["href"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_order_form_company_business_card = _resolveComponent("order-form-company-business-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_order_form_products_summary = _resolveComponent("order-form-products-summary")!
  const _component_order_form_container = _resolveComponent("order-form-container")!
  const _component_order_form_cost = _resolveComponent("order-form-cost")!
  const _component_order_form_lading_bill = _resolveComponent("order-form-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_company_business_card_form = _resolveComponent("company-business-card-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_miezz_customs_package = _resolveComponent("miezz-customs-package")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_miezz_hscode = _resolveComponent("miezz-hscode")!
  const _component_miezz_upload_cropper = _resolveComponent("miezz-upload-cropper")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_card, {
      fix: true,
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              rules: _ctx.form.Rules,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_order_form_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "业务类型" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.type), 1),
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_miezz_button, {
                                model: _ctx.btnDownloadTemplate,
                                onHandleClick: _ctx.handleClick
                              }, null, 8, ["model", "onHandleClick"]),
                              _createVNode(_component_miezz_button, {
                                model: _ctx.btnImportTemplate,
                                onHandleFileUpload: _ctx.handleFileUpload
                              }, null, 8, ["model", "onHandleFileUpload"])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.detail?.Status != _ctx.EnumOrderPoolStatus.WaitingAdd)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Booking No"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.BookingNo), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: 
                _ctx.logier?.CompanyType == _ctx.EnumCompanyType.ServiceProvider
                  ? '委托方的编号'
                  : '我的编号'
              
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.Code,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.Code) = $event)),
                            trimAll: true,
                            onHandleBlur: _ctx.handleCodeBlur
                          }, null, 8, ["modelValue", "onHandleBlur"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (_ctx.form.Data.DeparturePortWarehouse)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "预计到仓时间",
                            prop: "EstimatedAtWwarehouseDate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.form.Data.EstimatedAtWwarehouseDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.EstimatedAtWwarehouseDate) = $event)),
                                type: "date",
                                format: "YYYY/MM/DD HH:mm",
                                "value-format": "YYYY/MM/DD HH:mm",
                                class: "form-item-date"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "预计货好时间",
                            prop: "EstimatedGoodsReadyDate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.form.Data.EstimatedGoodsReadyDate,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.EstimatedGoodsReadyDate) = $event)),
                                type: "date",
                                format: "YYYY/MM/DD",
                                "value-format": "YYYY/MM/DD",
                                class: "form-item-date"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Loading/装货港",
                        prop: "LoadingPortId"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail?.OrderId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "el-input",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDisabledPortClick && _ctx.handleDisabledPortClick(...args)))
                              }, [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.form.Data.LoadingPortLabel), 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 1,
                                modelValue: _ctx.form.Data.LoadingPortId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.LoadingPortId) = $event)),
                                label: _ctx.form.Data.LoadingPortLabel,
                                "onUpdate:label": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.LoadingPortLabel) = $event)),
                                noDataText: '无匹配数据，请至参数管理中添加',
                                options: _ctx.loadingPorts,
                                remote: true,
                                remoteMethod: _ctx.getLoadingPorts,
                                placeholder: '请填写关键词'
                              }, null, 8, ["modelValue", "label", "options", "remoteMethod"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DischargePortId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.DischargePortId) = $event)),
                            label: _ctx.form.Data.DischargePortLabel,
                            "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.DischargePortLabel) = $event)),
                            noDataText: '无匹配数据，请至参数管理中添加',
                            options: _ctx.dischargePorts,
                            remote: true,
                            remoteMethod: _ctx.getDischargePorts,
                            placeholder: '请填写关键词'
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail?.OrderId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "el-input",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDisabledPortClick && _ctx.handleDisabledPortClick(...args)))
                              }, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.form.Data.DeliveryPortLabel), 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 1,
                                modelValue: _ctx.form.Data.DeliveryPortId,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.DeliveryPortId) = $event)),
                                label: _ctx.form.Data.DeliveryPortLabel,
                                "onUpdate:label": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.DeliveryPortLabel) = $event)),
                                options: _ctx.deliveryPorts,
                                remote: true,
                                remoteMethod: _ctx.getDeliveryPorts,
                                noDataText: '无匹配数据，请至参数管理中添加',
                                placeholder: '请填写关键词'
                              }, null, 8, ["modelValue", "label", "options", "remoteMethod"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            ref: "ref-delivery-place",
                            modelValue: _ctx.form.Data.DeliveryPlaceLabel,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceLabel) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName",
                            onHandleSelect: _ctx.handleSelectDeliveryPlace
                          }, null, 8, ["modelValue", "fetch-suggestions", "onHandleSelect"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: "DeliveryPlaceAddress"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.DeliveryPlaceAddress,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceAddress) = $event)),
                            type: "textarea",
                            rows: 3,
                            resize: "none",
                            trim: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.CarrierId,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.CarrierId) = $event)),
                            label: _ctx.form.Data.CarrierLabel,
                            "onUpdate:label": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.CarrierLabel) = $event)),
                            options: _ctx.carriers,
                            remote: true,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            remoteMethod: _ctx.getCarriers,
                            onVisibleChange: _cache[15] || (_cache[15] = 
                  (s) => {
                    if (s) _ctx.getCarriers();
                  }
                )
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "渠道",
                        prop: "TransportChannelId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportChannelId,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.TransportChannelId) = $event)),
                            label: _ctx.form.Data.TransportChannelLabel,
                            "onUpdate:label": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.TransportChannelLabel) = $event)),
                            options: _ctx.channels,
                            remote: true,
                            remoteMethod: _ctx.getChannels,
                            onVisibleChange: _cache[18] || (_cache[18] = 
                  (s) => {
                    if (s) _ctx.getChannels();
                  }
                )
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.ContractNo,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.ContractNo) = $event)),
                            upperCase: true,
                            trimAll: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.ShipName,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.ShipName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.VoyageNumber,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.VoyageNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.Flight,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.Flight) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.RailwayNumber,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.RailwayNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedDepartureDate,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.Data.EstimatedDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedArrivalDate,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.Data.EstimatedArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportPaymentType,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.TransportPaymentType) = $event)),
                            options: _ctx.EnumTransportPaymentTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.GoodsTransportType,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.Data.GoodsTransportType) = $event)),
                            options: _ctx.EnumGoodsTransportTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: "Remark"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.Remark,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.Remark) = $event)),
                            type: "textarea",
                            rows: 5,
                            resize: "none",
                            trim: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form"]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_el_form_item, {
                            label: "显示清单",
                            "label-width": "90px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: _ctx.form.Data.ShowPackages,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.Data.ShowPackages) = $event)),
                                onChange: _ctx.handleShowPackagesChanged
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          (_ctx.form.Data.ShowPackages)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                "label-width": "90px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: _ctx.packageType,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.packageType) = $event)),
                                    options: _ctx.packageTypes
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.form.Data.ShowPackages)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: "币制",
                                prop: "CurrencySystemId",
                                "label-width": "90px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: _ctx.form.Data.CurrencySystemId,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.Data.CurrencySystemId) = $event)),
                                    label: _ctx.form.Data.CurrencySystemLabel,
                                    "onUpdate:label": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.Data.CurrencySystemLabel) = $event)),
                                    options: _ctx.currencySystems
                                  }, null, 8, ["modelValue", "label", "options"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.form.Data.ShowPackages)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                "label-width": "0px",
                                style: {"color":"red"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 同一箱规的信息存在多个Shipment ID时，请拆分为多行信息添加 ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.form.Data.ShowPackages)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              (_ctx.packageType == 'Import')
                                ? (_openBlock(), _createBlock(_component_miezz_button, {
                                    key: 0,
                                    model: _ctx.btnImportPackages,
                                    onHandleClick: _ctx.handleClick
                                  }, null, 8, ["model", "onHandleClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.form.Data.ShowPackages)
                        ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                            key: 0,
                            modelValue: _ctx.listPackage,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.listPackage) = $event)),
                            onHandleRowButtonClick: _ctx.handlePackageRowButtonClick
                          }, {
                            column: _withCtx(({ model, row, index }) => [
                              (model.Prop == 'Code')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    prop: `Packages[${index}].${model.Prop}`,
                                    "label-width": "0px",
                                    rules: _ctx.packageRules.Code
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: row[model.Prop],
                                        "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"]))
                                : (model.Prop == 'Shapes' && row.ShapesLabel)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.handleShowModalPackageShapes(row, index))
                                    }, [
                                      _createVNode(_component_miezz_text_ellipsis, {
                                        text: row.ShapesLabel
                                      }, null, 8, ["text"])
                                    ], 8, _hoisted_13))
                                  : (model.Prop == 'GrossWeight')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 2,
                                        prop: `Packages[${index}].${model.Prop}`,
                                        rules: _ctx.listPackageRules.GrossWeight,
                                        "label-width": "0px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            modelValue: row[model.Prop],
                                            "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                                            pattern: "[0-9.]",
                                            number: true,
                                            numberFixed: 2,
                                            disabled: row.Shapes.all((it) => it.GrossWeight),
                                            onHandleBlur: _ctx.handleCalcPackagesNumber
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules"]))
                                    : (model.Prop == 'Volume')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 3,
                                          prop: `Packages[${index}].${model.Prop}`,
                                          rules: _ctx.listPackageRules.Volume,
                                          "label-width": "0px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: row[model.Prop],
                                              "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                                              pattern: "[0-9.]",
                                              number: true,
                                              numberFixed: 4,
                                              disabled: row.Shapes.all((it) => it.Volume),
                                              onHandleBlur: _ctx.handleCalcPackagesNumber
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : (model.Prop == 'Products' && row.ProductsLabel)
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 4,
                                            prop: `Packages[${index}].${model.Prop}`,
                                            rules: _ctx.form.Rules.PackageProducts,
                                            "label-width": "0px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", {
                                                onClick: ($event: any) => (_ctx.handleShowModalProductsLabel(row, index))
                                              }, [
                                                _createVNode(_component_miezz_text_ellipsis, {
                                                  text: row.ProductsLabel
                                                }, null, 8, ["text"])
                                              ], 8, _hoisted_14)
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"]))
                                        : (model.Prop == 'Quantity')
                                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                                              key: 5,
                                              prop: `Packages[${index}].${model.Prop}`,
                                              rules: _ctx.listPackageRules.Quantity,
                                              "label-width": "0px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_miezz_input, {
                                                  modelValue: row[model.Prop],
                                                  "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                                                  pattern: "[0-9]",
                                                  number: true,
                                                  greaterThanNumber: 0,
                                                  onHandleBlur: _ctx.handleCalcPackagesNumber
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["prop", "rules"]))
                                          : (
                    model.Prop == 'ShipmentId' &&
                    row.ShipmentIdLabel != undefined
                  )
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 6,
                                                onClick: ($event: any) => (_ctx.handleShowModalShipmentIdLabel(row, index))
                                              }, [
                                                _createVNode(_component_miezz_text_ellipsis, {
                                                  text: row.ShipmentIdLabel
                                                }, null, 8, ["text"])
                                              ], 8, _hoisted_15))
                                            : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onHandleRowButtonClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.ShowPackages && _ctx.packageType == 'Add')
                        ? (_openBlock(), _createBlock(_component_miezz_button, {
                            key: 1,
                            style: {"color":"#fe995b"},
                            model: _ctx.btnAddPackage,
                            onHandleClick: _ctx.handleClick
                          }, null, 8, ["model", "onHandleClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_order_form_products_summary, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"]),
                  (
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_form_container, {
                        key: 0,
                        form: _ctx.form,
                        "onUpdate:form": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form) = $event))
                      }, null, 8, ["form"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_form_cost, {
                    ref: "ref-order-form-cost",
                    form: _ctx.form,
                    "onUpdate:form": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form) = $event)),
                    currencySystem: _ctx.currencySystem,
                    currencySystems: _ctx.currencySystems,
                    hideCosts: 
            !_ctx.powerCodes?.contains('OrderManagement_Pool_Summary_Detail_Costs')
          ,
                    showSupplierCosts: 
            _ctx.powerCodes?.contains(
              'OrderManagement_Pool_Summary_Detail_SupplierCosts'
            )
          ,
                    showSettlementCosts: 
            _ctx.powerCodes?.contains(
              'OrderManagement_Pool_Summary_Detail_SettlementCosts'
            ) && _ctx.detail?.ClientCompanyBuildSettlementBill
          
                  }, null, 8, ["form", "currencySystem", "currencySystems", "hideCosts", "showSupplierCosts", "showSettlementCosts"]),
                  (_ctx.detail?.DeparturePortBooking && _ctx.detail.DeparturePortLadingBill)
                    ? (_openBlock(), _createBlock(_component_order_form_lading_bill, {
                        key: 1,
                        form: _ctx.form,
                        "onUpdate:form": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form) = $event)),
                        requireds: ['LadingBillType']
                      }, null, 8, ["form"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", null, [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.form.Data.Files,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                          path: "order/main-bill",
                          prop: "File",
                          maxSize: 2 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCard,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.modalBusinessCard) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_form, {
          modelValue: _ctx.modalBusinessCard,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.modalBusinessCard) = $event)),
          id: _ctx.businessCardId,
          companyId: _ctx.detail?.ClientCompanyId,
          parentId: _ctx.businessCardParentId,
          area: _ctx.businessCardArea,
          type: _ctx.businessCardType,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCard
        }, null, 8, ["modelValue", "id", "companyId", "parentId", "area", "type", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.clientCompanyId)
      ? (_openBlock(), _createBlock(_component_miezz_customs_package, {
          key: 0,
          currentCompanyId: _ctx.clientCompanyId,
          isSelectCompany: false,
          ref: "CustomsPackage",
          onOnSelectProductPackage: _ctx.onSelectProductPackage
        }, null, 8, ["currentCompanyId", "onOnSelectProductPackage"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageShapes,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.modalPackageShapes) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.listPackageShapes.Data,
          ref: "ruleFormPackageShapes",
          class: "rule-form-package-shapes"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listPackageShapes,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.listPackageShapes) = $event)),
              onHandleRowButtonClick: _ctx.handlePackageShapeRowButtonClick
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'Length')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Items[${index}].Length`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          greaterThanNumber: 0,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageShapeVolume(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Width')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Items[${index}].Width`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          greaterThanNumber: 0,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageShapeVolume(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Height')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Items[${index}].Height`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          greaterThanNumber: 0,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageShapeVolume(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'GrossWeight')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Items[${index}].GrossWeight`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          greaterThanNumber: 0
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Volume')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Items[${index}].Volume`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 4,
                          disabled: row.Length && row.Width && row.Height
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleRowButtonClick"]),
            (
          _ctx.form.Data.Packages &&
          _ctx.packageIndex != undefined &&
          (_ctx.form.Data.Packages[_ctx.packageIndex].Products?.length ?? 0) == 1
        )
              ? (_openBlock(), _createBlock(_component_miezz_button, {
                  key: 0,
                  style: {"color":"#fe995b"},
                  model: _ctx.btnAddPackageShape,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageProducts,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.modalPackageProducts) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.listPackageProducts.Data,
          ref: "ruleFormPackageProducts"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_miezz_page_list, {
              modelValue: _ctx.listPackageProducts,
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.listPackageProducts) = $event)),
              onHandleRowButtonClick: _ctx.handlePackageProductRowButtonClick,
              key: _ctx.random
            }, {
              "column-header": _withCtx(({ model }) => [
                (model.Prop == 'NameZh' || model.Prop == 'NameEn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString(model.Label), 1)
                    ]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice' || model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(model.Label), 1),
                      (_ctx.form.Data.CurrencySystemCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "（" + _toDisplayString(_ctx.form.Data.CurrencySystemCode) + "）", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'NameZh')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Items[${index}].NameZh`,
                      rules: _ctx.packageProductRules.NameZh,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[\\u4e00-\\u9fa5]",
                          trimAll: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'NameEn')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Items[${index}].NameEn`,
                      rules: _ctx.packageProductRules.NameEn,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[a-zA-Z\\s]",
                          trimManySpace: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'HsCode')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Items[${index}].HsCode`,
                      rules: _ctx.packageProductRules.HsCode,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          onHandleFocus: ($event: any) => (_ctx.chooseHsCode(row))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleFocus"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TradingCountryHsCode')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Items[${index}].TradingCountryHsCode`,
                      rules: _ctx.packageProductRules.TradingCountryHsCode,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SpecName')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Items[${index}].SpecName`,
                      rules: _ctx.packageProductRules.SpecName,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          trimAll: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Picture')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `Items[${index}].Picture`,
                      rules: _ctx.packageProductRules.Picture,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        (row.PictureUrl)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createElementVNode("a", {
                                class: "filename",
                                href: row.PictureUrl,
                                target: "_blank",
                                style: {"width":"100%","height":"100%"}
                              }, [
                                _createVNode(_component_el_image, {
                                  src: row.PictureUrl,
                                  style: {"width":"40px","height":"40px"},
                                  fit: "fill"
                                }, null, 8, ["src"])
                              ], 8, _hoisted_23),
                              _createElementVNode("div", {
                                class: "delete",
                                onClick: ($event: any) => (_ctx.deletePic(index))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Close)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_24)
                            ]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "primary",
                              text: "",
                              onClick: ($event: any) => (_ctx.handleOpen(row.Picture, index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode("上传附件")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Material')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `Items[${index}].Material`,
                      rules: _ctx.packageProductRules.Material,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Purpose')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `Items[${index}].Purpose`,
                      rules: _ctx.packageProductRules.Purpose,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Quantity')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `Items[${index}].Quantity`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          greaterThanNumber: 0,
                          disabled: 
                (_ctx.form.Data.Packages[_ctx.packageIndex].Shapes?.length ?? 0) > 1
              ,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageProductPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'ChargeUnitEn')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `Items[${index}].ChargeUnitEn`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row.ChargeUnitEn,
                          "onUpdate:modelValue": ($event: any) => ((row.ChargeUnitEn) = $event),
                          "fetch-suggestions": _ctx.getChargeUnitEns,
                          valueKey: "NameEn"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `Items[${index}].UnitPrice`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageProductTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 11,
                      prop: `Items[${index}].TotalPrice`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcPackageProductUnitPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleRowButtonClick"])),
            (
          _ctx.form.Data.Packages &&
          _ctx.packageIndex != undefined &&
          (_ctx.form.Data.Packages[_ctx.packageIndex].Shapes?.length ?? 0) == 1
        )
              ? (_openBlock(), _createBlock(_component_miezz_button, {
                  key: 0,
                  style: {"color":"#fe995b"},
                  model: _ctx.btnAddPackageProduct,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageShipmentId,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.modalPackageShipmentId) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.currentPackage,
          ref: "ruleFormPackageShipmentId",
          class: "rule-form-package-shipment-id",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Shipment ID",
              prop: "ShipmentId",
              class: "package-shipment-id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.currentPackage.ShipmentId,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.currentPackage.ShipmentId) = $event)),
                  trimAll: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Reference ID",
              prop: "ReferenceId",
              class: "package-shipment-id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.currentPackage.ReferenceId,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.currentPackage.ReferenceId) = $event)),
                  trimAll: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.ReferenceIds, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: i,
                label: `FBA No.${i + 1}`,
                prop: `ReferenceIds[${i}].ReferenceId`,
                class: "package-reference-id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_input, {
                    modelValue: item.ReferenceId,
                    "onUpdate:modelValue": ($event: any) => ((item.ReferenceId) = $event),
                    trimAll: true,
                    disabled: !_ctx.currentPackage.ShipmentId
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  (i != 0)
                    ? (_openBlock(), _createBlock(_component_miezz_button, {
                        key: 0,
                        model: _ctx.btnDeletePackageShipmentId,
                        onHandleClick: (arg1, arg2) => _ctx.handleDeletePackageShipmentId(i, arg2)
                      }, null, 8, ["model", "onHandleClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            }), 128)),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_button, {
                  model: _ctx.btnAddPackageShipmentId,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_hscode, {
      ref: "HsCode",
      onOnSelectHsCode: _ctx.selectHsCode
    }, null, 8, ["onOnSelectHsCode"]),
    (_openBlock(), _createBlock(_component_miezz_upload_cropper, {
      key: _ctx.random2,
      modelValue: _ctx.cropper,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.cropper) = $event)),
      onHandleClose: _ctx.handleClose,
      onGetImg: _ctx.getImg
    }, null, 8, ["modelValue", "onHandleClose", "onGetImg"])),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalImportLog,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.modalImportLog) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importLogs, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "log-item",
            key: i
          }, [
            _createVNode(_component_el_alert, {
              title: item.Message,
              type: item.Type,
              effect: item.Effect,
              closable: false
            }, null, 8, ["title", "type", "effect"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}